export default __webpack_public_path__ + "static/media/cadLogo.105cef35.png";